import { ICreative } from '@/Interfaces/Creatives/Creative.interface';
import TableActionButton from '@/components/Buttons/TableActionButton';
import ConfirmationModal from '@/components/Modal/ConfirmationModal';
import { CREATIVE_IN_USE_ARCHIVE_DISABLED_REASON } from '@/constants/creativeLibrary';
import { Tooltip } from '@mui/material';
import { useCallback, useState } from 'react';

interface IProps {
  row: ICreative;
  handleArchive: (ids: number[], isArchived: boolean) => Promise<void>;
}

const ArchiveButton = ({ row, handleArchive }: IProps) => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const isBlocked = !row.isArchived && !!row.isInUse;

  const onConfirm = useCallback(async () => {
    await handleArchive([row.id], !row.isArchived);
    setIsConfirmationOpen(false);
  }, [handleArchive, row]);

  return (
    <>
      <Tooltip title={isBlocked ? CREATIVE_IN_USE_ARCHIVE_DISABLED_REASON : ''}>
        <span>
          <TableActionButton
            variant='outlined'
            color='primary'
            disabled={isBlocked}
            onClick={() => setIsConfirmationOpen(true)}
          >
            {row.isArchived ? 'Unarchive' : 'Archive'}
          </TableActionButton>
        </span>
      </Tooltip>
      {isConfirmationOpen && (
        <ConfirmationModal
          open={isConfirmationOpen}
          onClose={() => setIsConfirmationOpen(false)}
          onConfirm={onConfirm}
          text={`Are you sure you want to ${row.isArchived ? 'unarchive' : 'archive'} this creative "${row.name}"?`}
        />
      )}
    </>
  );
};

export default ArchiveButton;
